import qs from "qs";
export default {
    wxShowMenu:function(){    
        let pageurl = location.href.split('#')[0];
        let queryData = { url: pageurl };
        const _this=this;
        return new Promise((resolve, reject) => {
                const _showLog = this.showLog;
                const _name = '';
                const _method = window.fdConfig.methodPost;
                const _url = window.fdConfig.url.common('wxshare');
                const _data = queryData;
                // 输出日志
                window.fdGlobal.consoleLogRequest(_showLog, _name, _method, _url, _data);
                //  返回shuju
                window.fdGlobal.ajax({
                    method: _method,
                    url: _url,
                    // URL参数
                    // 必须是一个纯对象或者 URL参数对象
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: qs.stringify(_data),
                    //params: '',
                    // 默认值是json
                    responseType: 'json'
                }).then((data) => {
                    var getMsg = data.data;
                    wx.config({
                        debug: false,
                        appId: getMsg.appId,
                        timestamp: getMsg.timestamp,
                        nonceStr: getMsg.nonceStr,
                        signature: getMsg.signature,
                        jsApiList: [
                            'scanQRCode',
                        ],
                    });
                     wx.ready(function (res) {
                        wx.scanQRCode({
                            needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                            success: function (res) {
                                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                            }
                        });
                    });
                    const _serverData = data.data;
                    resolve(_serverData);
                }, (data) => {
                    reject(data);
                });
            });
    }
    
}


// WEBPACK FOOTER //
// ./src/js/wx.jsapi.js